export default "__VITE_ASSET__kjRJ6MQW__"